import type { FinancialMetricMode } from '../model/types'

const FINANCIAL_METRIC_MODE_BY_VALUE = {
  net: 'net',
  ndp: 'ndp',
  npd: 'ndp',
  tnet: 'tnet',
} as const

export const normalizeFinancialMetricMode = (value?: string | null): FinancialMetricMode | null => {
  const normalizedValue = value?.trim().toLowerCase()

  if (!normalizedValue) {
    return null
  }

  return (
    FINANCIAL_METRIC_MODE_BY_VALUE[
      normalizedValue as keyof typeof FINANCIAL_METRIC_MODE_BY_VALUE
    ] ?? null
  )
}
